<template>
	<div class="aiHistoryCom">
		<el-drawer v-model="drawer" :direction="direction" :before-close="handleClose" :size="drawerSize"
			:lock-scroll="true" :modal="true" :close-on-click-modal="true" :show-close="true" :with-header="false">
			<!-- <template #header>

			</template> -->
			<template #default>
				<div class="aiHistory_content">
					<div class="aiHistory_header">
						<i class="iconfont icon-icon_close" style="margin-right: 25px;" @click="aiHistoryClose"></i>
					</div>
					<div class="aiHistory_box">
						<aiHistoryView :isDrawer='openDrawerFlag' ref="aiHistoryViewRef" @openDialog="onOpenDialog" @closeDialog="aiHistoryClose"></aiHistoryView>
					</div>
					<aiHistoryDialog :dialogType="dialogType" :parmas="parmas" ref="aiHistoryDialogRef" @onConfirm="onConfirm" />
				</div>
			</template>

		</el-drawer>
	</div>
</template>

<script setup lang='ts'>

import { ref, reactive, watch } from "vue";
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n();
import type { DrawerProps } from 'element-plus'
const aiHistoryView = defineAsyncComponent(() => import("@/components/aiTranslateComponents/aiHistoryView.vue"))
const aiHistoryDialog = defineAsyncComponent(() => import("@/components/aiTranslateComponents/aiHistoryDialog.vue"))
import { isMobileOrTablet } from "@/utils"

const router = useRouter();
const route = useRoute();

const drawerSize  = ref('35%')
const direction = ref<DrawerProps['direction']>('ltr')
const drawer = ref(false)

const openDrawerFlag = ref(false);
const aiHistoryViewRef = ref(null)

const dialogType = ref(0)
const parmas = ref({})
const aiHistoryDialogRef = ref(null)
const localePath = useLocalePath();
defineExpose({ aiHistoryOpen, aiHistoryClose })

function aiHistoryOpen() {
	console.log("aiHistoryOpen====")
	openDrawer();
	aiHistoryViewRef.value && aiHistoryViewRef.value.onGetHistoryList()
}
const emit = defineEmits(['close']);
function aiHistoryClose() {
	
	emit('close');
	// step.value = 1
	// onClearInput()
	// onCheck()
	closeDrawer()
}
const openDrawer = () => {
	drawer.value = true
	openDrawerFlag.value = true;
}
const closeDrawer = () => {
	drawer.value = false
	openDrawerFlag.value = false;
	aiHistoryViewRef.value && aiHistoryViewRef.value.onExit()
	aiHistoryViewRef.value && aiHistoryViewRef.value.onClearInput()
}
const handleClose = (done: () => void) => {
	aiHistoryViewRef.value && aiHistoryViewRef.value.onExit()
	aiHistoryViewRef.value && aiHistoryViewRef.value.onClearInput()
	done()
}
const onHome = () => {
	navigate('/');
}
const navigate = (name) => {
	// 跳转页面前，关闭当前弹窗
	aiHistoryClose()
	router.push({
		path: localePath(name)
	})
}

function onOpenDialog(type, data) {
	dialogType.value = type
	parmas.value = data

	aiHistoryDialogRef.value && aiHistoryDialogRef.value.openDialog()
}

function onConfirm(type, inputText, parmas) {
	console.log('onConfirm===', type, inputText, parmas)
	aiHistoryViewRef.value && aiHistoryViewRef.value.onConfirm(type, inputText, parmas)
}

onMounted(() => {
	if (import.meta.client) {
		if (isMobileOrTablet()) {
			drawerSize.value = '100%'
		} 
	}
	window.addEventListener('resize', () => {
		if (window.innerWidth < 576) {
			drawerSize.value = '100%'
		} else {
			drawerSize.value = '77%'
		}
	})
})

onUnmounted(() => {
	window.removeEventListener('resize', () => {})
})
</script>

<style scoped lang='less'>
.aiHistory_content{
	position: absolute;
	top:0;
	left:0;
	right:0;
	bottom:0;
	width: 100%;
	display: flex;
	// justify-content: space-between;
	flex-direction: column;
	.functional_Area{
		background-color: #E5F2FB;
		width:300px;
		padding:140px 0 0 30px;
		img{
			width:40px;
			height:18px;
			// margin-bottom: 10px;
		}

	}
	.aiHistory_header{
		z-index: 2;
		display: flex;
		padding: 0px 0;
		width: 100%;
		align-items: center;
		justify-content: flex-end;
		height: 107px;
		i{
			font-size: 24px;
			cursor: pointer;
		}
	}
	.aiHistory_box{
		width: 100%;
		height: calc(100% - 127px);
		display: flex;
		position: relative;
	}
}

</style>